// import components
import { styled, Box } from '@mui/material';

export const StyledDialogContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  maxWidth: 800,
  margin: 'auto',
  padding: theme.spacing(0, 1.25)
}));

export const StyledTopContentBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  gap: theme.spacing(4),
  borderBottom: `1px solid ${theme.palette.grey[300]}`,
  padding: theme.spacing(1, 0, 4, 0)
}));

export const StyledDialogBox = styled(Box)(({ theme }) => ({
  minWidth: 360,
  padding: 10,

  '& .MuiDialogTitle-root': {
    padding: 10,
    borderBottom: `1px solid ${theme.palette.grey[300]}`,
    marginBottom: 10,
    fontSize: 18
  },

  '& .MuiDialogContent-root': {
    padding: 0,
    marginBottom: 0,
    fontSize: 16,
    fontFamily: 'SourceSansPro-Regular',
    whiteSpace: 'pre-line',

    p: {
      margin: 0
    }
  },

  '&.info .MuiDialogTitle-root': {
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main
  }
}));
